import { Button, TitleBar } from "modules/common";
import { IProfileResetMobilePasswordProps } from "modules/common/components/ProfileResetMobilePassword/types/IProfileResetMobilePasswordProps";
import { useContext } from "react";
import { AccessibilityContext } from "views/AccessibilityContext";

export function ProfileResetMobilePassword({
    profile,
    toggleResetMobilePasswordModal,
}: IProfileResetMobilePasswordProps) {
    const { fontSize, lowVision } = useContext(AccessibilityContext);
    if (!profile?.isActive) return null;
    return (
        <section>
            <TitleBar>
                <TitleBar.Left>
                    <span
                        className="title-bar-text profile-title"
                        style={{ fontSize: `${fontSize}%` }}
                    >
                        Promjena lozinke mobilne aplikacije
                    </span>
                </TitleBar.Left>
            </TitleBar>
            <Button
                className="reset-password-button"
                type="button"
                variant="warning"
                lowVision={lowVision}
                size="small"
                onClick={toggleResetMobilePasswordModal}
            >
                <span className="reset-password-text">Promjeni lozinku</span>
            </Button>
        </section>
    );
}
